import type { FaireProductEntity } from "../../entity_types/product";

export const stone_lamp: FaireProductEntity = {
  token: "stone-lamp",
  type: "product",
  name: "Stone Portable LED Lamp",
  brandName: "Ninth House Goods",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/5f2ab75c67c3c46db324f3e8ed776d2a6f9ab95710a461dd3e636730314726d9.webp",
  priceDollars: 66,
  msrpDollars: 144,
  freeShipping: false,
  isBestseller: false,
  description: "",
  categoryTokens: ["cat_proto_home-and-living"],
  tags: [],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-products-migration",
  },
};
